import { render, staticRenderFns } from "./baformu.vue?vue&type=template&id=6aac93ab&scoped=true"
import script from "./baformu.vue?vue&type=script&lang=js"
export * from "./baformu.vue?vue&type=script&lang=js"
import style0 from "./baformu.vue?vue&type=style&index=0&id=6aac93ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aac93ab",
  null
  
)

export default component.exports